// Import the necessary libraries

// Function to fetch the VTT file from blob storage
export async function fetchBlobUrl(url) {
    if (!url) {
        console.error('No URL provided');
        return null;
    }
    try {
        const response = await fetch(url, { cache: 'reload' });
        const blobData = await response.text();
        return blobData;
    } catch (error) {
        console.error('Error fetching Blob file:', error);
        return null;
    }
}
